import React from "react";
import { motion } from "framer-motion";

// orientation: "horizontal" | "vertical"
// animated: draws in via scaleX/scaleY when in view
export function GlowLine({
    orientation = "horizontal",
    animated = false,
    length = "100%",
    className = "",
    style = {},
    delay = 0,
    duration = 1.2,
}) {
    const isH = orientation === "horizontal";
    const base = isH ? "glow-line" : "glow-line-vertical";
    const sizeStyle = isH
        ? { width: length, height: undefined }
        : { height: length, width: undefined };

    if (!animated) {
        return <div className={`${base} ${className}`} style={{ ...sizeStyle, ...style }} />;
    }

    return (
        <motion.div
            className={`${base} ${className}`}
            style={{
                ...sizeStyle,
                transformOrigin: isH ? "left center" : "top center",
                ...style,
            }}
            initial={{ scaleX: isH ? 0 : 1, scaleY: isH ? 1 : 0, opacity: 0 }}
            whileInView={{ scaleX: 1, scaleY: 1, opacity: 1 }}
            viewport={{ once: true, margin: "50px" }}
            transition={{ duration, delay, ease: [0.25, 0.1, 0.25, 1] }}
        />
    );
}
